import React from "react";
import { connect } from "react-redux";
import history from "../../auth/history";
import moment from "moment";
import { toHaveFocus } from "@testing-library/jest-dom/dist/matchers";

class AddConsumerDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            val: ''
        }
    }


    componentDidMount() {
        if (this.props.consumerAddResp != undefined &&
            this.props.consumerAddResp != null) {
            const map = new Map(Object.entries(this.props.consumerAddResp.optional));
            var mapKeys = [...map.keys()];
            var val = "";
            mapKeys.map(key => {
                val = val + key + " : " + map.get(key) + ";"
            })
        }
        this.setState({
            val: val
        })

    }
    componentWillUnmount() {
    }


    printdiv = (event) => {
		event.preventDefault();
		var divContents = document.getElementById("loaddtl").innerHTML;
        
        
		var a = window.open('', '', 'height=1000, width=1000');
		a.document.write('<html>');
		a.document.write('<body>');
		a.document.write(divContents);
		a.document.write('</body></html>');
		a.document.close();
		a.print();

        // var printContents = document.getElementById(divName).innerHTML;
        // var originalContents = document.body.innerHTML;
   
        // document.body.innerHTML = printContents;
   
        // window.print();
   
        // document.body.innerHTML = originalContents;
	}


    render() {

        return (
            <div class="loaddtl" >
                {this.props.consumerAddResp != undefined &&
                    this.props.consumerAddResp != null &&
                    <div id="loaddtl">
                        <h4>Thank you, Consumer Details has been submited successfully!</h4>
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <td width="150">Consumer Name:</td>
                                        <td>{this.props.consumerAddResp.consumerName}</td>
                                    </tr>
                                    <tr>
                                        <td>Mobile No.:</td>
                                        <td>{this.props.consumerAddResp.mobileNo}</td>
                                    </tr>
                                    {this.state.val != '' &&
                                        this.state.val != null &&
                                        this.state.val != undefined &&
                                        this.state.val.split(";").map(v => (
                                            v != "" &&
                                            v != undefined &&
                                            v != null &&
                                            <tr>
                                                <td>{v.split(":")[0].toLocaleUpperCase()}</td>
                                                <td>{v.split(":")[1].toLocaleUpperCase()}</td>
                                            </tr>
                                        ))

                                    }
                                    <tr>
                                        <td>Biller Name:</td>
                                        <td>{this.props.consumerAddResp.billerName}</td>
                                    </tr>
                                    <tr>
                                        <td>State:</td>
                                        <td>{this.props.consumerAddResp.state}</td>
                                    </tr>
                                    <tr>
                                        <td>City:</td>
                                        <td>{this.props.consumerAddResp.city}</td>
                                    </tr>
                                    <tr>
                                        <td>Branch ID:</td>
                                        <td>{this.props.consumerAddResp.branchNameOrId}</td>
                                    </tr>
                                    <tr>
                                        <td>Email ID:</td>
                                        <td>{this.props.consumerAddResp.mailId}</td>
                                    </tr>
                                    <tr>
                                        <td>Date:</td>
                                        <td>{moment(this.props.consumerAddResp.createdOn).format('DD-MM-YYYY HH:mm:ss')}</td>
                                    </tr>
                                    <tr>
                                        <td>Reference ID:</td>
                                        <td>{this.props.consumerAddResp.id}</td>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>

                }
                <div class="txn-btn">
                    <button type="button" class="print" onClick={this.printdiv}>Print</button>
                    {/* <button type="button" class="share">Share</button>
							<button type="button" class="help">Support</button> */}
                </div>
            </div>

        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage },
        miscReduce: { phone, consumerAddResp } }
) => ({
    errorMessage, phone, consumerAddResp
});

export default connect(mapStateToProps, null)(AddConsumerDetails);
